(() => {
  'use strict';

  // The script can be output by more than one block. Bind delegated listeners once.
  if (window.__xoGroupedStyleColorPickerBlockLoaded) return;
  window.__xoGroupedStyleColorPickerBlockLoaded = true;

  const PICKER_SELECTOR = '[data-grouped-style-color-picker-block]';
  const BUTTON_SELECTOR = '[data-grouped-style-color-picker-button]';

  function allPickers() {
    return Array.from(document.querySelectorAll(PICKER_SELECTOR));
  }

  function nativeGroup(picker, optionName) {
    return Array.from(picker.querySelectorAll('[data-grouped-native-option]')).find(
      (group) => group.dataset.groupedNativeOption === optionName
    );
  }

  function nativeInput(picker, optionName, optionValue) {
    const group = nativeGroup(picker, optionName);
    if (!group) return null;

    return Array.from(group.querySelectorAll('input[type="radio"]')).find(
      (input) => input.value === optionValue
    ) || null;
  }

  function selectedValue(picker, optionName) {
    const group = nativeGroup(picker, optionName);
    if (!group) return '';

    const checked = Array.from(group.querySelectorAll('input[type="radio"]')).find(
      (input) => input.checked
    );

    return checked ? checked.value : '';
  }

  function syncPicker(picker) {
    const selectedStyle = selectedValue(picker, picker.dataset.groupedStyleOptionName);
    const selectedColor = selectedValue(picker, picker.dataset.groupedColorOptionName);

    picker.querySelectorAll(BUTTON_SELECTOR).forEach((button) => {
      const selected =
        button.dataset.styleValue === selectedStyle &&
        button.dataset.colorValue === selectedColor;

      button.classList.toggle('is-selected', selected);
      button.setAttribute('aria-pressed', selected ? 'true' : 'false');
    });
  }

  function syncAllPickers() {
    allPickers().forEach(syncPicker);
  }

  function makeInputRepresentVariant(input, variantId, available) {
    if (!input) return;

    // The theme reads xo-variant-id from the input that emits the input event.
    // Set it to the complete Style + Color variant before that event is fired.
    input.checked = true;
    input.setAttribute('xo-variant-id', String(variantId));
    input.removeAttribute('xo-unavailable');

    if (available) {
      input.removeAttribute('xo-disabled');
    } else {
      input.setAttribute('xo-disabled', '');
    }
  }

  document.addEventListener('click', (event) => {
    const button = event.target.closest(BUTTON_SELECTOR);

    if (!button || button.disabled || button.getAttribute('aria-disabled') === 'true') {
      return;
    }

    const picker = button.closest(PICKER_SELECTOR);
    if (!picker) return;

    const styleInput = nativeInput(
      picker,
      picker.dataset.groupedStyleOptionName,
      button.dataset.styleValue
    );

    const colorInput = nativeInput(
      picker,
      picker.dataset.groupedColorOptionName,
      button.dataset.colorValue
    );

    if (!styleInput || !colorInput) return;

    event.preventDefault();

    const variantId = button.dataset.variantId;
    const available = button.dataset.available === 'true';

    // Select both option values first, then send one input event. This prevents
    // the original product form from temporarily resolving an incomplete pair.
    makeInputRepresentVariant(styleInput, variantId, available);
    makeInputRepresentVariant(colorInput, variantId, available);

    colorInput.dispatchEvent(new Event('input', { bubbles: true }));
    syncPicker(picker);
  });

  // Keep the visual card state aligned when another native picker changes the variant.
  document.addEventListener('input', (event) => {
    if (event.target.matches('input[xo-option-value-id], select')) {
      window.requestAnimationFrame(syncAllPickers);
    }
  });

  document.addEventListener('shopify:section:load', syncAllPickers);
  window.addEventListener('pageshow', syncAllPickers);
  window.addEventListener('popstate', () => {
    window.requestAnimationFrame(syncAllPickers);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncAllPickers, { once: true });
  } else {
    syncAllPickers();
  }
})();